import { getBlazeoLeadGuid } from "@/modules/crm/leads/components/lead-details/right-section/appointment/routing-helpers";

const pinned = new Map();

const idsOf = (event, eventId) =>
  [
    eventId,
    event?.id,
    event?.eventId,
    event?.thirdPartyAppointmentId,
    event?.appointmentId,
  ]
    .filter((id) => id != null && id !== "")
    .map(String);

export const pinLeadAppointment = (event, eventId) => {
  if (!event) return;
  idsOf(event, eventId).forEach((id) => pinned.set(id, event));
};

export const unpinLeadAppointment = (eventId, event) => {
  const match = new Set(idsOf(event, eventId));
  for (const [key, value] of [...pinned.entries()]) {
    if (match.has(key) || idsOf(value).some((id) => match.has(id))) {
      pinned.delete(key);
    }
  }
};

/** Keep a remotely inserted event when a lead-list fetch resolves without it. */
export const mergePinnedLeadAppointments = (items, leadGuid) => {
  const list = items || [];
  const serverIds = new Set();
  list.forEach((item) => idsOf(item).forEach((id) => serverIds.add(id)));

  const extras = [];
  const seen = new Set();
  for (const [key, event] of [...pinned.entries()]) {
    if (serverIds.has(key) || idsOf(event).some((id) => serverIds.has(id))) {
      pinned.delete(key);
      continue;
    }
    const eventIds = idsOf(event);
    if (eventIds.some((id) => seen.has(id))) continue;

    const eventLead = getBlazeoLeadGuid(event?.leadId, event?.LeadId);
    if (
      leadGuid &&
      eventLead &&
      eventLead.toLowerCase() !== String(leadGuid).toLowerCase()
    ) {
      continue;
    }

    eventIds.forEach((id) => seen.add(id));
    extras.push(event);
  }

  return extras.length ? [...extras, ...list] : list;
};
